import React, { ReactElement } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

export const ExpandIconRenderComponent = ({ expanded, onExpand, record }: any): ReactElement =>
  expanded
    ? (
      <UpOutlined
        onClick={(e): void => {
          onExpand(record, e);
        }}
      />
    )
    : (
      <DownOutlined
        onClick={(e): void => {
          onExpand(record, e);
        }}
      />
    );
